export default {
  //reducer const
  SET_CATALOG_ITEMS: 'SET_CATALOG_ITEMS',
  CATALOG_ITEMS: 'CATALOG_ITEMS',
  LINK: 'LINK',
  CATEGORY_POINTER: 'CATEGORY_POINTER',
  REFERENCE: 'REFERENCE',
  CATEGORY_INFO: 'CATEGORY_INFO',
  FOLDER: 'FOLDER',
  NEW_WINDOW: 'NEW_WINDOW',
  SUBMIT_INCIDENT: 'SUBMIT_INCIDENT',
  SUBMIT_REQUEST: 'SUBMIT_REQUEST',
  REQUEST_TEMPLATE_LINK: 'REQUEST_TEMPLATE_LINK',
  INCIDENT_TEMPLATE_LINK: 'INCIDENT_TEMPLATE_LINK',
  FAQ_ITEM: 'FAQ_ITEM',
  SET_CATALOG_ITEMS_WITH_BRANCH: 'SET_CATALOG_ITEMS_WITH_BRANCH',
  CURRENT_BRANCHES: 'CURRENT_BRANCHES',
  ADD_BRANCH_TO_CURRENT_BRANCHES: 'ADD_BRANCH_TO_CURRENT_BRANCHES',
  REMOVE_BRANCH_FROM_CURRENT_BRANCHES: 'REMOVE_BRANCH_FROM_CURRENT_BRANCHES',
  SET_SYSAI_CHATBOT_CALALOG_ITEM: 'SET_SYSAI_CHATBOT_CALALOG_ITEM',
  SYSAI_CHATBOT_CALALOG_ITEM: 'SYSAI_CHATBOT_CALALOG_ITEM',
  SYSAI_CHATBOT_SC_ID: -10
};



// WEBPACK FOOTER //
// ./constants/serviceCatalog.js